import { Injectable } from '@angular/core';
import {Headers, ResponseContentType} from '@angular/http';
import { SessionService } from './session.service';
import { ConfigService } from '../../config/config.service';
import { httpExtensionService } from './httpextension.service';

@Injectable()
export class SettingsService {

    markets: any[] = [
        { value: 2, label: 'All' },
        { value: 0, label: 'Santa Barbara' },
        { value: 1, label: 'Ventura' }
    ];

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService) { }

    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }

    getSalesRep(salesRepId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getSalesRep(salesRepId), {
            headers: headers
        });
    }

    listSalesRep(userData) {
        let body = userData;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.salesRepList, body, {
            headers: headers
        })
    }

    createSalesRep(data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.createSalesRep, body, {
            headers: headers
        });
    }

    updateSalesRep(salesRepId, data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.put(this.config.updateSalesRep(salesRepId), body, {
            headers: headers
        });
    }

    getBeneficiary(beneficiaryId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getBeneficiary(beneficiaryId), {
            headers: headers
        });
    }

    getFundraisors(){
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.fundraisorslist, {
            headers: headers
        });
    }

    listBeneficiary(userData) {
        const body = userData;
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.beneficiaryList, body, {
            headers: headers
        });
    }

    createBeneficiary(data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.createBeneficiary, body, {
            headers: headers
        });
    }

    updateBeneficiary(beneficiaryId, data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.put(this.config.updateBeneficiary(beneficiaryId), body, {
            headers: headers
        });
    }

    importBeneficiaryFile(data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.importBeneficiaryFile, body, {
            headers: headers
        });
    }

    getBeneficiaryMembershipsReport(beneficiaryId, filters) {
        const body = filters;
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.getBeneficiaryMembershipsReport(beneficiaryId), body, {
            headers: headers,
            responseType: ResponseContentType.ArrayBuffer
        }).map(res => new Blob([res._body],{ type: 'application/vnd.ms-excel' }));
    }

    getBeneficiaryRedemptionsReport(beneficiaryId, filters) {
        const body = filters;
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.getBeneficiaryRedemptionsReport(beneficiaryId), body, {
            headers: headers,
            responseType: ResponseContentType.ArrayBuffer
        }).map(res => new Blob([res._body], { type: 'application/vnd.ms-excel' }));
    }

    getBeneficiariesSummaryReport(reportFilters) {
        const body = reportFilters;
        const user_token: string = this.sessionService.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.beneficiariesSummaryReport, body, {
            headers: headers,
            responseType: ResponseContentType.ArrayBuffer
        }).map(res => new Blob([res._body], { type: 'application/vnd.ms-excel' }));
    }

    listMarkets(userData) {
        let body = userData;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.marketsList, body, {
            headers: headers
        })
    }

    createMarket(data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.createMarket, body, {
            headers: headers
        });
    }

    updateMarket(marketId, data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.put(this.config.updateMarket(marketId), body, {
            headers: headers
        });
    }

    updateMarketImages(marketId, data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        //headers.append('Content-Type', 'multipart/form-data');
        return this.http.put(this.config.updateMarketImages(marketId), body, {
            headers: headers
        });
    }

    getMarket(marketId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getMarket(marketId), {
            headers: headers
        });
    }

    getAllCategories(data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.apiURI + this.config.allCategoriesList, body, {
            headers: headers
        });
    }

    getCategoriesAndSubCat() {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.basePath + 'api/v2/' + this.config.getCatAndSubCat(false), {
            headers: headers
        });
    }

    createCategory(data) {
        const body = data;
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.createCategory, body, {
            headers: headers
        });
    }

    updateCategory(catId, data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        //headers.append('Content-Type', 'multipart/form-data');
        return this.http.put(this.config.updateCategory(catId), body, {
            headers: headers
        });
    }

    orderCategories(data) {
        let body = data;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.put(this.config.apiURI + this.config.orderCategories(), body, {
            headers: headers
        });
    }

    getCategory(catId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getCategory(catId), {
            headers: headers
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/settings.service.ts